var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-component"},[_vm._v("\n  "+_vm._s(_vm.config.msg)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }